module.exports = __webpack_public_path__ + "img/music.efedd73d.png";